export const UAE_WHATSAPP_NUMBER = '+971 52 725 4909';
export const UAE_WHATSAPP_LINK = 'https://wa.me/971527254909';

const LANG_KEY = 'bf_lang';

export const isAeDomain = () =>
  typeof window !== 'undefined' && window.location.hostname.endsWith('.ae');

export const getInitialLang = () => {
  try {
    const param = new URLSearchParams(window.location.search).get('lang');
    if (param === 'ar' || param === 'en') return param;
    const stored = localStorage.getItem(LANG_KEY);
    if (stored === 'ar' || stored === 'en') return stored;
  } catch (e) {
    // storage blocked — fall through to domain check
  }
  return isAeDomain() ? 'ar' : 'en';
};

export const setStoredLang = (lang) => {
  try {
    localStorage.setItem(LANG_KEY, lang);
  } catch (e) {
    // storage blocked — non-fatal
  }
};

export const isUaeMode = () => getInitialLang() === 'ar';
